import { Typography, useTheme } from "@mui/material";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { Reminder } from "web_myplann/Reminders/Types/ReminderTypes";
import { formatReminderDate } from "web_myplann/Reminders/Utils/formatReminderDate";

type Props = {
	reminder: Reminder;
};

export const ReminderRowMeta = ({ reminder }: Props) => {
	const { t } = useResource();
	const theme = useTheme();

	const recurrence = t(Resources.Reminders.Recurrence[reminder.recurrence]);

	return (
		<>
			<Typography variant="hint" color={theme.palette.grey[500]}>
				{t(Resources.Reminders.Row.subtitle, {
					date: formatReminderDate(reminder.date),
					recurrence,
				})}
			</Typography>
			{reminder.snoozedUntil && (
				<Typography variant="hint" color={theme.palette.grey[500]}>
					{t(Resources.Reminders.Badge.snoozedUntil, {
						date: formatReminderDate(reminder.snoozedUntil),
					})}
				</Typography>
			)}
		</>
	);
};
